import { Box, BoxProps } from '@chakra-ui/react';
import { useEffect } from 'react';

interface PageProps extends BoxProps {
  title?: string;
}

/**
 * @description - Used to wrap an entire page. First child is the header, second child is the main content.
 */
export default function Page(props: PageProps) {
  const { title, children, ...otherProps } = props;

  useEffect(() => {
    document.title = title ? `${title} - Alitu` : 'Alitu';
  }, [title]);

  return (
    <Box
      as="section"
      w="100%"
      minH="100vh"
      minW="max-content"
      bg="podcastShade100"
      zIndex="1"
      alignItems="stretch"
      {...otherProps}
    >
      {children}
    </Box>
  );
}

/**
 * @description - Main content container. This should go after the page header.
 */
export function PageContentContainer(props: BoxProps) {
  return (
    <Box as="main" {...contentContainerProps} {...props}>
      {props.children}
    </Box>
  );
}

export const contentContainerProps = {
  maxWidth: '68.75rem',
  py: '1.875rem',
  mx: 'auto',
};
